import Column from '@app/components/layout/Column'
import { Event } from '@app/components/blocks/event/Event'
import { Title } from '@app/components/core/typography/Title'
import { useLocale, useTranslations } from '@i18n/useLanguage'
import { ServiceProviderViewModel } from 'functions/app/service-provider/view'

export const Events = ({
  serviceProvider,
}: {
  serviceProvider?: ServiceProviderViewModel
}) => {
  const locale = useLocale()
  const translations = useTranslations().app
  return (
    <Column>
      <Title.H4>{translations.serviceProviderPage.events}</Title.H4>
      {serviceProvider.events &&
        serviceProvider.events.map((event) => {
          const startDate = new Date(event.start)

          return (
            <Event
              key={event.uuid}
              date={startDate.getDate()}
              month={startDate.toLocaleDateString(locale, {
                month: 'long',
              })}
              category={event.category}
              title={event.title}
              intro={event.intro}
              time={startDate.toLocaleTimeString(locale, {
                hour: '2-digit',
                minute: '2-digit',
              })}
              location={event.location?.address || 'Unknown'}
              onClick={() => console.warn('Event clicked!')}
            />
          )
        })}
    </Column>
  )
}
